<template>
   <div>
       <div v-if="couponsList[0] && (couponsList[0].coupon_type == 2)">
           <div class="horizontal-wrap">
               <router-link
                :to="{ path: '/detail/' + item.id }"
                v-for="(item,index) in shopList" :key="index"
               class="page-background-color-white page-relative acea-row row-middle row-between shop-module">
                   <img class="image" :src="item.image" />
                   <div class="acea-row row-column row-column-between right-wrap">
                       <p class="line2 titles">
                           {{ item.store_name }}
                       </p>
                       <div class="bottom-wrap">
                           <span class="price">&nbsp;</span>
                           <span class="sales">&nbsp;</span>
                       </div>
                   </div>
                   <img class="page-absolute icon" :src="require('@/assets/images/index-shop-list-icon.png')" />
               </router-link>
           </div>
       </div>
       <div v-else>
           <div class="horizontal-wrap">
               <router-link
                :to="{ path: '/detail/' + item.id }"
                v-for="(item,index) in shopList" :key="index"
               class="page-background-color-white page-relative acea-row row-middle row-between shop-module">
                   <img class="image" :src="item.image" />
                   <div class="acea-row row-column row-column-between right-wrap">
                       <p class="line2 titles">
                           {{ item.store_name }}
                       </p>
                       <div class="bottom-wrap">
                           <span class="price">{{ item.price }}</span>
                           <span class="sales">已售{{ item.sales }}{{ item.unit_name }}</span>
                       </div>
                   </div>
                   <img class="page-absolute icon" :src="require('@/assets/images/index-shop-list-icon.png')" />
               </router-link>
           </div>
       </div>
   </div>
</template>

<script>
export default {
    name: "HorizontalList",
    data: function() {
        return {

        }
    },
    props: {
        shopList: {
            type: Array,
            default: []
        },
        couponsList: {
            type: Array,
            default: []
        }
    }
}
</script>

<style scoped lang="scss">
 .horizontal-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0.22rem;
 }
 .shop-module {
     width: 100%;
     height: 2.24rem;
     margin-bottom: 0.16rem;
     border-radius: 0.16rem;
     box-sizing: border-box;
     padding: 0.32rem 0.62rem 0.32rem 0.32rem;
     .image {
         width: 1.6rem;
         height: 1.6rem;
         border-radius: 0.16rem;
         margin-right: 0.16rem;
     }
     .right-wrap {
         width: 4.16rem;
         height: 1.64rem;
     }
     .titles {
         min-height: 0.7rem;
     }
     .price {
        font-size: 0.36rem;
        color:#F64A44;
    }
    .sales {
        font-size: 0.24rem;
        color: #BEBEBE;
        margin-left: 0.08rem;
    }
    .icon {
        width: 0.28rem;
        height: 0.28rem;
        top: 1.54rem;
        right: 0.16rem;
    }
 }
</style>